<template>
    <div class="content-view"
         v-loading="is_loading"
         element-loading-text="loading...">
        <div class="content-inner" v-html="content"></div>
    </div>
</template>
<script>
    import API from '../../assets/api'
    import marked from 'marked'
    var rendererMD = new marked.Renderer();
    marked.setOptions({
        renderer: rendererMD,
        gfm: true,
        tables: true,
        breaks: true,
        pedantic: true,
        sanitize: true,
        smartLists: true,
        smartypants: true
    });
    marked.setOptions({
        highlight: function (code) {
            return hljs.highlightAuto(code).value;
        }
    });
    export default {
        data () {
            return {
                content: '',
                is_loading: false
            }
        },
        created () {
            this.fetchArticleById();
        },
        methods: {
            fetchArticleById () {
                this.is_loading = true;
                API.Req_FetchArticleById(this.$route.params.id).then((article) => {
                    setTimeout(() => {
                        this.is_loading = false;
                    },300);
                    this.content = marked(article);
                });
            }
        }
    }
</script>
<style lang="scss">
    @import '../../assets/scss/define';
    .content-view{
        background-color: #fff;
        background-position: center center;
        background-size: contain;
        padding: 20px 0;
    }
    .content-inner{
        @extend %ma;
        font-size: 16px;
        max-width: 960px;
        min-height: 100%;
        pre{
            padding: 16px;
            overflow: auto;
            font-size: 85%;
            line-height: 1.45;
            background-color: #f6f8fa;
            border-radius: 3px;
            color: #24292e;
        }
        h1{
            padding-bottom: 0.3em;
            font-size: 2em;
            border-bottom: 1px solid #eaecef;
        }
        blockquote {
            margin: 16px 0;
            padding: 0 1em;
            color: #6a737d;
            border-left: 0.25em solid #dfe2e5;
        }
        h2 {
            padding-bottom: 0.3em;
            font-size: 1.5em;
            border-bottom: 1px solid #eaecef
        }
        h3 {
            font-size: 1.25em;
            padding: 20px 0 10px;
        }
        h4 {
            font-size: 1em
        }
        h5 {
            font-size: 0.875em
        }
        h6 {
            font-size: 0.85em;
            color: #6a737d
        }
        p {
            @extend %f14;
            margin-top: 0;
            margin-bottom: 16px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/content/content.vue